import {useFundamentalMuiTheme} from '@hconnect/uikit'
import {ThemeProvider} from '@mui/material'
import {RouteObject} from 'react-router'

import {EventsAffiliatesPage} from '../pages'

const ShiftEventsAffiliatesRouteWrapper = () => {
  return (
    <ThemeProvider theme={useFundamentalMuiTheme()}>
      <EventsAffiliatesPage />
    </ThemeProvider>
  )
}

export const eventsAffiliatesRoutes: RouteObject = {
  path: '',
  element: <ShiftEventsAffiliatesRouteWrapper />
}
